<template lang="html"></template>

<script>

export default {

	data() {
		return {

		}
	},

	mounted() {
		window.print()
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PrintPage.vue